import { err, ok, Result } from "neverthrow"
import type { CalcRuntimeExprValue } from "./RuntimeTypes"

// see also CalcScriptCompileEnv
export class CalcRuntimeEnv {
	private vars: Map<string, CalcRuntimeExprValue> = new Map()

	// Runtime accessors for Evaluator
	getValue(name: string): Result<CalcRuntimeExprValue, string> {
		const value = this.vars.get(name)
		if(value === undefined) {
			return err(`Variable '${name}' has not been evaluated yet`)
		}
		return ok(value)
	}

	setValue(name: string, value: CalcRuntimeExprValue): void {
		this.vars.set(name, value)
	}
}
